import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Warning, X, Trash } from "@phosphor-icons/react";

export default function ConfirmDeleteClubModal({ open, club, onClose, onDeleted }) {
  const [confirmText, setConfirmText] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  if (!open || !club) return null;
  const expected = club.name || "";
  const matches = confirmText.trim() === expected;

  const handleDelete = async () => {
    setBusy(true);
    setErr("");
    try {
      const res = await api.delete(`/super/clubs/${club.id}`);
      onDeleted?.(res.data);
      onClose?.();
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-3" onClick={onClose} data-testid="delete-club-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />
      <div className="surface relative w-full max-w-md p-5" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-md bg-[#ff0026]/15 flex items-center justify-center">
              <Warning size={20} weight="fill" className="text-[#ff0026]" />
            </div>
            <h2 className="font-heading uppercase text-xl tracking-tight">Delete club</h2>
          </div>
          <button onClick={onClose} className="btn-ghost"><X size={16} weight="bold" /></button>
        </div>
        <p className="text-sm text-zinc-300 mb-3">
          This will permanently remove <strong className="text-white">{club.name}</strong> and all of its data —
          users, players, evaluations, squads, invites, assignments, taxonomy and audit logs.
        </p>
        <p className="text-xs text-[#ff0026] bg-[#ff0026]/10 border border-[#ff0026]/30 rounded p-2 mb-3">
          This action cannot be undone.
        </p>
        <label className="font-label block mb-1">Type the club name to confirm</label>
        <input
          className="input"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder={expected}
          data-testid="delete-confirm-input"
          autoFocus
        />
        {err && <div className="mt-3 text-sm text-[#ff0026]" data-testid="delete-error">{err}</div>}
        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onClose} className="btn-ghost" disabled={busy}>Cancel</button>
          <button
            onClick={handleDelete}
            disabled={!matches || busy}
            className="btn-primary"
            style={{ background: matches ? "#ff0026" : undefined, color: matches ? "#fff" : undefined, borderColor: matches ? "#ff0026" : undefined }}
            data-testid="delete-confirm-btn"
          >
            <Trash size={14} weight="bold" /> {busy ? "Deleting…" : "Delete forever"}
          </button>
        </div>
      </div>
    </div>
  );
}
